// AI assisted development
export const AppAttributeEnum = {
  DisableCompleteOrderBeforePosDone: 'DisableCompleteOrderBeforePosDone',
  AllowCCAddNewItem: 'AllowCCAddNewItem',
  AllowCCEditOrder: 'AllowCCEditOrder',
  BaseSkOrmServiceUri: 'BaseSkOrmServiceUri',
  ConsolidatedSubsApiExperience: 'ConsolidatedSubsApiExperience'
};
